import { render, staticRenderFns } from "./AlertNow.vue?vue&type=template&id=86c360a6"
import script from "./AlertNow.vue?vue&type=script&lang=js"
export * from "./AlertNow.vue?vue&type=script&lang=js"
import style0 from "./AlertNow.vue?vue&type=style&index=0&id=86c360a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports